import React from 'react';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import { showDeleteAlert, showAdvancedModeAlert, showDeleteTrackAlert } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import { setCurrentSlide } from '../../actions/CurrentSlideActions';
import { needsRefresh } from '../../actions/SlideViewerActions';
import { deleteSlide }  from '../../actions/ProductionActions';
import mouseUtils from '../../components/utils/MouseUtils';
import { connect } from 'react-redux';
import playController from '../utils/PlayController';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import audioUtils from '../utils/AudioUtils';
import { deleteTrack } from '../../actions/AudioEditorActions';
import apiServiceUtils from '../utils/ApiServiceUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.showDeleteTrackAlert)
            this.deleteTrack();
        else
        if (this.props.showAdvancedModeAlert)
            this.advancedMode();
        else
            this.deleteSlideMode();
    },
    advancedMode() {
        if (this.props.index == 1) {
            playController.toggleAudioEditorMode(true);
            audioUtils.clearAudioEvents();
            audioEditorUtils.addActionToHistory();
        }

        this.props.dispatch(showAdvancedModeAlert(false));
    },
    deleteSlideMode() {
        if (this.props.index == 1) { //YES, button
            const state = storeManager.getState();
            const slides = state.production.slides;
            let newSlideIndex;

            if (slides.length == 1) {
                newSlideIndex = 0;
            }
            else {
                if (slides.length - 1 == state.currentSlide.currentSlideIndex)
                    newSlideIndex = state.currentSlide.currentSlideIndex - 1;
                else
                    newSlideIndex = state.currentSlide.currentSlideIndex;
            }

            playController.getOldScrollPosition();

            this.props.dispatch(deleteSlide());
            this.props.dispatch(setCurrentSlide(newSlideIndex));
            this.props.dispatch(needsRefresh(true));
            audioEditorUtils.addActionToHistory();
            audioEditorUtils.checkMarkerPositionForCurrentSlide();
            audioEditorUtils.checkTimelineWidth();

            playController.updateScrollPosition(200, true);
        }

        this.props.dispatch(showDeleteAlert(false));
    },
    deleteTrack() {
        if (this.props.index == 1) { //YES, button
            var trackMenuIndex = audioEditorUtils.currentTrackMenu;

            if (trackMenuIndex >= 0)
                this.props.dispatch(deleteTrack(trackMenuIndex));
        }

        this.props.dispatch(showDeleteTrackAlert(false));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var fillColor;

        if (this.state.isOver == true) {
            fillColor = properties.SLIDE_VIEWER_BACKGROUND;
            textColor = 'black';
        } else if (this.props.index == 0) {
            textColor = 'black';
            fillColor = 'white';
        } else {
            textColor = 'white';
            fillColor = '#444444';
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: properties.DELETE_ALERT_BUTTON_WIDTH,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            textAlign: 'left'
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            fontSize: 16,
            width: properties.DELETE_ALERT_BUTTON_WIDTH - 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        var idValue;

        if (this.props.index == 0)
            idValue = 'deleteAlertFirstFocusableElement';
        else
            idValue = 'deleteAlertLastFocusableElement';

        return (
            <button id={idValue} aria-label={this.props.text} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const DeleteAlertContent = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        return true;
        if (this.props.showDeleteAlert != newProps.showDeleteAlert || this.props.showAdvancedModeAlert != newProps.showAdvancedModeAlert || this.props.showDeleteTrackAlert != newProps.showDeleteTrackAlert || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight)
            return true;
        else
            return false;
    },
    render() {
        var visible = 'none';

        if (this.props.showDeleteAlert == true || this.props.showAdvancedModeAlert == true || this.props.showDeleteTrackAlert == true)
            visible = 'block';
        else
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: properties.DELETE_ALERT_BACKGROUND_OPACITY
        };

        const alertHolderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - (properties.DELETE_ALERT_TOP_BAR_HEIGHT + properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT) / 2,
            left: this.props.windowWidth / 2 - properties.DELETE_ALERT_WIDTH / 2
        };

        const topBarStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            top: 0,
            left: 0,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND
        };

        const bottomBarStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT,
            top: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            left: 0,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'white'
        };

        const titleStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 6,
            fontSize: 22,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: 'white'
        };

        const questionStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 20,
            fontSize: 16,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            height: properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 3 * properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line'
        };

        var title = locales.getCaption('DeleteAlertTitle', 'deleteAlert');
        var question = locales.getCaption('DeleteAlertQuestion', 'deleteAlert');
        var cancelCaption = locales.getCaption('DeleteAlertCancel', 'deleteAlert');
        var okCaption = locales.getCaption('DeleteAlertYes', 'deleteAlert');

        if (this.props.showAdvancedModeAlert) {
            title = locales.getCaption('AdvancedModeTitle', 'deleteAlert');
            question = locales.getCaption('AdvancedModeQuestion', 'deleteAlert');
            okCaption = locales.getCaption('AdvancedModeYes', 'deleteAlert');
        }
        else if (this.props.showDeleteTrackAlert) {
            title = locales.getCaption('DeleteTrackAlertTitle', 'deleteAlert');
            question = locales.getCaption('DeleteTrackAlertQuestion', 'deleteAlert');
        }

        return (
            <div style={menuStyle} id="deleteAlert">
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={topBarStyle}>
                        <span style={titleStyle}>{title}</span>
                    </div>
                    <div style={bottomBarStyle}>
                        <div style={questionStyle}>{question}</div>
                        <Button showDeleteTrackAlert={this.props.showDeleteTrackAlert} showAdvancedModeAlert={this.props.showAdvancedModeAlert} dispatch={this.props.dispatch} topPosition={properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP - 2 * properties.DELETE_ALERT_BUTTON_WIDTH} index={0} text={cancelCaption}/>
                        <Button showDeleteTrackAlert={this.props.showDeleteTrackAlert} showAdvancedModeAlert={this.props.showAdvancedModeAlert} dispatch={this.props.dispatch} topPosition={properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={properties.DELETE_ALERT_WIDTH - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_WIDTH} index={1} text={okCaption}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showDeleteAlert = state.menu.showDeleteAlert;
    const showAdvancedModeAlert = state.menu.showAdvancedModeAlert;
    const showDeleteTrackAlert = state.menu.showDeleteTrackAlert;

    return {
        showDeleteAlert,
        showAdvancedModeAlert,
        showDeleteTrackAlert
    };
}

export const DeleteAlert = connect(mapStateToProps)(DeleteAlertContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/DeleteAlert.js
 **/